import { memo } from "react";
import { Modal } from "react-bootstrap";
import useToggle from "../../Hooks/useToggle";
import "./style.css";

const ImageViewer = (props) => {

    const { src, text, image_style = {}, image_classname = "" } = props
    const [open, _, toggle] = useToggle();

    return (
        <>
            {
                text ? <p className="m-0 text-primary text cursor-pointer" onClick={toggle}>{text}</p> :
                    <img src={src} onClick={toggle} style={image_style} className={`${image_classname} cursor-pointer`} />
            }
            {
                open &&
                <Modal
                    show={open}
                    onHide={toggle}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Body className="d-flex align-items-center justify-content-center popup-body">
                        <img className="popup-image" src={src} />
                    </Modal.Body>
                </Modal>
            }
        </>
    )
}

export default memo(ImageViewer)